import { useEffect } from "react"

import { toast } from "sonner"

function startSse<T>(url: string, onMessage: (content: string) => void, onCompleted: (payload: T) => void) {
    const chunks: string[] = []
    const sse = new EventSource(url)
    sse.addEventListener("message", (ev) => {
        const data = JSON.parse(ev.data)
        if (data) {
            chunks.push(data)
            onMessage(chunks.join(""))
        }
    })
    sse.addEventListener("close", (ev) => {
        sse.close()
        const msg = JSON.parse(ev.data)
        if (msg.error) {
            toast.error(msg.error.execution_failed, {
                description: msg.error.message,
                duration: 5000,
            })
        }
        onCompleted(msg)
    })
    return () => {
        sse.close()
    }
}

export function useEventSource<T>(url: string | (() => Promise<string>), onMessage: (content: string) => void, onCompleted: (payload: T) => void) {
    useEffect(() => {
        if (typeof url === "function") {
            url().then((url) => startSse(url, onMessage, onCompleted))
        } else {
            startSse(url, onMessage, onCompleted)
        }
    }, [url])
}
